/* Component Dependencies */
var stepIndicatorTemplate = require('templates/stepIndicator.hbs');
var AriesComponent = require('libs/aries-component');
var Popup = require('libs/popup');

AriesComponent.create({
  type: 'stepIndicator',
  template: {
    'stepIndicator': stepIndicatorTemplate
  },
  events: {
    'click .js-erf-back-button': 'backAndSubmit'
  },
  bindEvents: function() {
    var showPopup = new Popup({
      selector: '.tile-step-indicator .mi-popover',
      url: this.$el.find('.js-reslink-back-button').attr('href'),
      sourceBlock: '.modal-content'
    });
    showPopup.register();
  },
  backAndSubmit : function(event){
    var _self = this, hiddenInput, form,
    editValue = event.currentTarget.value;
    hiddenInput = '<input type="hidden" name="'+editValue+'" '+' value="'+editValue+'" />';
    form  =  _self.$el.closest('form');
    form.append(hiddenInput);
    form.submit();
  }
});
